import { useState } from 'react';

const points = [
  {
    icon: 'ri-hospital-line',
    title: '医療用成分配合',
    desc: '歯科医師の診療のもとでのみ処方可能。市販品とは成分・効果がが異なります。',
  },
  {
    icon: 'ri-time-line',
    title: '1回30分、週1～2日でOK',
    desc: '忙しい方でも続けやすい短時間ケア。就寝前や家事の合間などお手軽にご使用可能です。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '2週間で実感',
    desc: '個人差はありますが、多くの方が2週間以内に白さの変化を実感しています。',
  },
  {
    icon: 'ri-home-smile-line',
    title: '自宅で完結',
    desc: 'ご来店不要。ご自宅で本格的な医療ホワイトニングが可能です。',
  },
];

export default function ProductDetail() {
  return (
    <section id="product-detail" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">

        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-[#E3F2FD] text-[#2C5AA0] text-xs font-bold rounded-full tracking-widest mb-4">MEDICAL WHITENING SHEET</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">医療ホワイトニングシートとは</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto leading-relaxed">
            歯科医師の診療を経て処方される、ホームホワイトニングシートです。<br />
            市販品では実現できない成分・濃度で、確かな白さがご自宅で実現可能に。
          </p>
        </div>

        {/* About Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/28d60a7bbb85336a61e36fc9fee8b306/b922d77959e9584cdc6d14a0369a0cc1.png"
              alt="医療ホワイトニングシート"
              className="w-full h-[420px] object-cover rounded-3xl shadow-xl"
            />
            <div className="absolute -bottom-5 -right-5 bg-[#2C5AA0] text-white rounded-2xl px-6 py-4 shadow-lg">
              <p className="text-xs font-medium opacity-80">市販品との違い</p>
              <p className="text-2xl font-bold mt-0.5">医療用薬剤</p>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-500 leading-relaxed mb-8">
              一般的な市販のホワイトニング製品は、安全基準上、使用できる成分の種類や濃度に制限があります。
              医療ホワイトニングシートは、歯科医師の診療・処方のもとでのみ使用できる医療用成分を配合。
              クリニックで行うオフィスホワイトニングに近い効果を、ご自宅で実現します。
            </p>

            <div className="grid grid-cols-2 gap-4">
              {points.map((point, i) => (
                <div key={i} className="bg-[#F8FBFD] rounded-2xl p-5 border border-gray-100">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#E3F2FD] rounded-xl mb-3">
                    <i className={`${point.icon} text-xl text-[#2C5AA0]`}></i>
                  </div>
                  <p className="text-sm font-bold text-gray-900 mb-1">{point.title}</p>
                  <p className="text-xs text-gray-500 leading-relaxed">{point.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* LINE Button */}
        <div className="flex justify-center mt-14">
          <a
            href="https://lin.ee/voFYYoK"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 text-sm md:px-10 md:py-4 md:text-lg bg-[#00C853] text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl md:text-2xl"></i>
            公式LINEで無料相談・ご予約はこちら
          </a>
        </div>

      </div>
    </section>
  );
}
